/**
 * Returns whether the specified element contains the specified CSS
 * class name.
 */
export default function hasClass(element, className) {
  return !!element.className.match(new RegExp("(\\s|^)".concat(className, "(\\s|$)")));
}
//# sourceMappingURL=hasClass.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/~/@flowio/browser-helpers/dist/esm/hasClass.js
// module id = 629
// module chunks = 0 1